var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcn24X24SearchWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.04167 0.5C2.71235 0.5 0 3.21235 0 6.54167C0 9.87098 2.71235 12.5833 6.04167 12.5833C7.48182 12.5833 8.80571 12.0746 9.84538 11.2292L13.9331 15.3169C13.9907 15.3769 14.0597 15.4248 14.136 15.4578C14.2123 15.4907 14.2945 15.5082 14.3776 15.509C14.4608 15.5099 14.5433 15.4941 14.6202 15.4627C14.6972 15.4312 14.7672 15.3848 14.826 15.326C14.8848 15.2672 14.9312 15.1972 14.9627 15.1202C14.9941 15.0433 15.0099 14.9608 15.009 14.8776C15.0082 14.7945 14.9907 14.7123 14.9578 14.636C14.9248 14.5597 14.8769 14.4907 14.8169 14.4331L10.7292 10.3454C11.5746 9.30571 12.0833 7.98182 12.0833 6.54167C12.0833 3.21235 9.37099 0.5 6.04167 0.5ZM6.04167 1.75C8.69544 1.75 10.8333 3.8879 10.8333 6.54167C10.8333 7.83442 10.3234 9.00238 9.49626 9.86279C9.44527 9.90027 9.40027 9.94527 9.36279 9.99626C8.50238 10.8234 7.33442 11.3333 6.04167 11.3333C3.3879 11.3333 1.25 9.19543 1.25 6.54167C1.25 3.8879 3.3879 1.75 6.04167 1.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn24X24SearchWhite);
export default __webpack_public_path__ + "static/media/icn_24x24_search_white.084cb4cfbf428a0b472ebb3b6281aef6.svg";
export { ForwardRef as ReactComponent };